// src/oura/ui/pageSlots.ts
//
// The staff business header belongs to the chrome (BusinessDetail), but its
// sentence and some of its actions belong to the screen under it. Rather than
// lifting state up through a setter (which a screen calling it from render
// turns into a loop), the chrome renders two empty nodes and the screen
// portals into them with <PageSentence> and <PageActions>.

import { createContext } from "react";

export interface PageSlotTargets {
    sentence: HTMLElement | null;
    actions: HTMLElement | null;
}

export interface PageSlotRegistry {
    targets: PageSlotTargets;
    setSentence: (el: HTMLElement | null) => void;
    setActions: (el: HTMLElement | null) => void;
}

export const PageSlotContext = createContext<PageSlotRegistry | null>(null);
